import { Component, OnDestroy, OnInit } from '@angular/core';
import { FacilityInformationType } from '@cargos/sprintpay-services';
import { Subject, takeUntil } from 'rxjs';
import { LocationService } from 'src/app/shared/services/locations.service';

@Component({
    selector: 'app-facility-information',
    templateUrl: './facility-information.component.html',
    styleUrls: ['./facility-information.component.scss'],
    standalone: false,
})
export class FacilityInformationComponent implements OnInit, OnDestroy {
    public facilityInformation: FacilityInformationType[];
    public isLoading: boolean;
    private unsubscribe$: Subject<void>;

    constructor(private locationsService: LocationService) {
        this.unsubscribe$ = new Subject<void>();
    }

    ngOnInit(): void {
        this.getFacilityLocations();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    getFacilityLocations(): void {
        this.isLoading = true;
        this.locationsService
            .getFacilityLocations()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((information) => {
                this.isLoading = false;
                this.facilityInformation = information?.map((item: FacilityInformationType) => {
                    item.phone = item.phone || 'N/A';
                    item.firmsCode = item.firmsCode || 'N/A';
                    return item;
                });
            });
    }
}
